import {
  JOURNEY_EMBED_MODE,
  LANGUAGE
} from '@epilot/journey-logic-commons/src/types/next'
import { z } from 'zod'

const stringBoolSchemaFactory = (defaultValue?: boolean) => {
  const base = z
    .string()
    .toLowerCase()
    .optional()
    .transform((val) =>
      typeof val === 'undefined' ? undefined : val === 'true'
    )

  if (typeof defaultValue === 'undefined') {
    return base.pipe(z.boolean())
  }

  return base.pipe(z.boolean().default(defaultValue))
}

const StepStateSchema = z.record(
  z.string(),
  z.union([
    z.unknown(),
    z
      .object({
        _isValid: z.boolean().optional()
      })
      .passthrough()
  ])
)

const BlockDisplaySettingSchema = z.object({
  type: z.literal('DISABLED'),
  blockName: z.string(),
  stepIndex: z.number().min(0),
  blockFields: z.array(z.string()).optional()
})

const DataInjectionOptionsSchema = z.object({
  initialStepIndex: z.number().min(0).optional(),
  initialState: z.array(StepStateSchema).optional(),
  blocksDisplaySettings: z.array(BlockDisplaySettingSchema).optional()
})

export const ParamsSchema = z
  .object({
    journeyId: z.string().optional(),
    debug: stringBoolSchemaFactory(false),
    preview: stringBoolSchemaFactory(false),
    topBar: stringBoolSchemaFactory(false),
    mode: z
      .nativeEnum(JOURNEY_EMBED_MODE)
      .optional()
      .default(JOURNEY_EMBED_MODE.FULL_SCREEN),
    isEmbedded: stringBoolSchemaFactory(false),
    lang: z.nativeEnum(LANGUAGE).optional().default(LANGUAGE.DE),
    journeyToken: z.string().optional(),
    journey_token: z.string().optional(), // deprecated
    nonce: z.string().optional(),
    dataInjectionOptions: z
      .string()
      .base64()
      .optional()
      .transform((value) => {
        try {
          if (value) return JSON.parse(atob(value))

          return undefined
        } catch (originalError) {
          return undefined
        }
      })
      .pipe(DataInjectionOptionsSchema.optional())
      .catch(undefined)
  })
  .transform((params) => {
    // normalize journeyToken
    // TODO: remove support for `journey_token` in the future
    if (params.journey_token && !params.journeyToken) {
      params.journeyToken = params.journey_token
    }

    delete params.journey_token

    return params
  })
